<div class="row">
  <div class="col-md-12">
    <button
    type="button"
    class="close pull-right close-profile"
    aria-label="close"
    (click)="close()"
    >
    <span aria-hidden="true">×</span>
    </button>
  </div>
</div>
<div class="profile-pop">

  <div class="top-row">

    <div
      class="text-center mt-1 pro-img"
      *ngIf="profileImage == null || profileImage == ''"
    >
      <div class="">
        <h3
          class="h-8 w-8 border-2 text-gray-800 rounded-full p-1 border-gray-600"
          style="text-transform: uppercase"
        >
          {{ getFirstLetters(FullName) }}
        </h3>
      </div>
    </div>
  
    <div
      class="text-center mt-1 pro-img"
      *ngIf="profileImage != null && profileImage != ''"
    >
      <img
        [src]="profileImage"
        style="height: 122px; width: 122px"
        class="rounded-full inline-block shadow-md border border-gray-400 p-1 bg-white"
      />
    </div>
    <div class="pro-nm">{{ userName }}</div>
    <!-- <a  class="edit" tooltip="Edit Profile"><i class="fa fa-pencil" aria-hidden="true"></i> </a> -->
  </div>
  <div class="login-time" *ngIf="lastLogin">
    <div>Last login at: {{ lastLogin | date : "MMM dd, y hh:mm a" }}</div>
  </div>
  <div class="d-flex flex-row pro-details">
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6 mr-2 inline-block"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
        />
      </svg>
      Full Name:
    </div>
    <div class="font-semibold">{{ FullName }}</div>
  </div>
  <div class="d-flex flex-row pro-details">
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6 mr-2 inline-block"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
        />
      </svg>
      Email:
    </div>
    <strong>{{ Email }}</strong>
  </div>
  <div class="text-center">
    <!-- <a class="btn page-btn mx-1" (click)="close()">Close</a> -->
  </div>
</div>

